import { FaArrowRight, FaBars, FaRegClock } from "react-icons/fa";
import { FaChartColumn } from "react-icons/fa6";
import './index.css';
import Hexagons from "../../Components/Hexagons";
import SpotlightCard from "../../Components/SpotlightCards";
import Carousel from "../../Components/Carousel";
import useIsMobile from "../../Hooks/isMobile";
import { GoPeople } from "react-icons/go";
import { BsLightningCharge } from "react-icons/bs";
import { useState } from "react";
import { NotepadText, StickyNote } from "lucide-react";
import { LuMonitorX } from "react-icons/lu";

function LandingPage() {
    const isMobile = useIsMobile();
    const [isOpen, setIsOpen] = useState(false)

    function OpenHeader() {
        const container = document.getElementById('header-container');

        if (isOpen) {
            container.style.height = '0px';
            setTimeout(() => {
                container.style.display = 'none'
            }, 400);
            setIsOpen(false);
        } else {
            container.style.display = 'flex'
            container.style.height = (container.scrollHeight + 15) + 'px';
            setIsOpen(true);
        }
    }

    return (
        <div>
            {isMobile ? (
                <div>
                    <header id="header">
                        <img src="./assets/banner.png" alt="Logo Tessilion" style={{ margin: '1rem 0', maxHeight: '4rem' }} />
                        <FaBars color="white" size={40} onClick={() => OpenHeader()} />
                    </header>
                    <div id="header-container" className="flex-mobile">
                        <p>O Tessilion</p>
                        <p onClick={() => window.location.href = '#third-section'}>Funcionalidades</p>
                        <button onClick={() => window.open('https://app.tessilion.com', '_blank')}>Em breve</button>
                    </div>
                </div>
            )
                : (
                    <header id="header">
                        <div>
                            <img src="./assets/banner.png" alt="Logo Tessilion" style={{ margin: '1rem 0', maxHeight: '4rem' }} />
                        </div>
                        <div id="header-container" className="flex-mobile">
                            <p>O Tessilion</p>
                            <p onClick={() => window.location.href = '#third-section'}>Funcionalidades</p>
                            <button onClick={() => window.open('https://app.tessilion.com', '_blank')}>Em breve</button>
                        </div>
                    </header >
                )
            }
            <div id='first-section'>
                {!isMobile &&
                    <div className="hexagon-background">
                        <Hexagons />
                    </div>
                }
                <h1 id='title'>Transforme seu negócio.</h1>
                <img src='./assets/icon.png' alt="Logo Tessilion" />
                <p className="section-description">
                    Sistema ERP acessível para pequenos comércios, que integra em um só sistema todas as principais funcionalidades que um comércio necessita.
                </p>
                <div className="flex-mobile button-container">
                    <button className="try-out" onClick={() => window.open('https://app.tessilion.com', '_blank')}>
                        <span>Em breve</span>
                        <FaArrowRight size={20} />
                    </button>
                    <button id="contact" onClick={() => window.location.href = 'mailto:projeto.tessilion@gmail.com'}>Contato</button>
                </div>
            </div>

            <div id="second-section">
                <h1>O problema que resolvemos</h1>

                <p className="section-description">
                    O projeto se baseia na falta de organização e estrutura interna que muitos comércios em ascensão no mercado enfrentam. Ademais, muitos ERPs existentes apresentam interfaces complexas e pouco intuitivas, além de, muitas vezes, não serem acessíveis para pessoas com deficiência.
                </p>

                {isMobile ? (
                    <Carousel autoplay loop>
                        <SpotlightCard className="custom-spotlight-card" spotlightColor="#fe5f2f">
                            <div className="card-icon">
                                <FaChartColumn size={30} />
                            </div>
                            <h4>Gestão fragmentada</h4>
                            <p>A maioria dos ERPs atuais não possuem todas as funcionalidades que uma empresa necessita, como a organização de tarefas e a geração de comunicados para a equipe.</p>
                        </SpotlightCard>
                        <SpotlightCard className="custom-spotlight-card" spotlightColor="#fe5f2f">
                            <div className="card-icon">
                                <LuMonitorX size={30} />
                            </div>
                            <h4>Interfaces complexas</h4>
                            <p>A maioria dos ERPs atuais contam com interfaces complexas e de difícil usabilidade, comprometendo na qualidade de uso do software.</p>
                        </SpotlightCard>
                        <SpotlightCard className="custom-spotlight-card" spotlightColor="#fe5f2f">
                            <div className="card-icon">
                                <GoPeople size={30} />
                            </div>
                            <h4>Acessibilidade Limitada</h4>
                            <p>A maioria dos ERPs atuais não possuem funcionalidades e interfaces que permitem a usabilidade do sistema por pessoas com deficiência.</p>
                        </SpotlightCard>
                    </Carousel>
                ) : (
                    <div className="card-container">
                        <SpotlightCard className="custom-spotlight-card" spotlightColor="#fe5f2f">
                            <div className="card-icon">
                                <FaChartColumn size={30} />
                            </div>
                            <h4>Gestão fragmentada</h4>
                            <p>A maioria dos ERPs atuais não possuem todas as funcionalidades que uma empresa necessita, como a organização de tarefas e a geração de comunicados para a equipe.</p>
                        </SpotlightCard>
                        <SpotlightCard className="custom-spotlight-card" spotlightColor="#fe5f2f">
                            <div className="card-icon">
                                <LuMonitorX size={30} />
                            </div>
                            <h4>Interfaces complexas</h4>
                            <p>A maioria dos ERPs atuais contam com interfaces complexas e de difícil usabilidade, comprometendo na qualidade de uso do software.</p>
                        </SpotlightCard>
                        <SpotlightCard className="custom-spotlight-card" spotlightColor="#fe5f2f">
                            <div className="card-icon">
                                <GoPeople size={30} />
                            </div>
                            <h4>Acessibilidade Limitada</h4>
                            <p>A maioria dos ERPs atuais não possuem funcionalidades e interfaces que permitem a usabilidade do sistema por pessoas com deficiência.</p>
                        </SpotlightCard>
                    </div>
                )}
            </div>

            <div id="third-section">
                <h1>Sistema modular e integrado</h1>

                <p className="section-description">O Tessilion consiste em um sistema modular que visa unir todas as principais funcionalidades que um comércio necessita, em um só lugar.</p>

                {isMobile ? (
                    <Carousel autoplay loop>
                        <SpotlightCard className="custom-spotlight-card" spotlightColor="#fe5f2f">
                            <div className="card-icon">
                                <FaRegClock size={30} />
                            </div>
                            <h4>Registro de Ponto Eletrônico</h4>
                            <p>O módulo de ponto eletrônico conta com um sistema físico, que registra a entrada e saída de colaboradores através de um crachá.</p>
                        </SpotlightCard>
                        <SpotlightCard className="custom-spotlight-card" spotlightColor="#fe5f2f">
                            <div className="card-icon">
                                <GoPeople size={30} />
                            </div>
                            <h4>Acessibilidade Garantida</h4>
                            <p>O sistema conta com funcionalidades e uma interface que permitem a sua utilização por pessoas com deficiência.</p>
                        </SpotlightCard>
                        <SpotlightCard className="custom-spotlight-card" spotlightColor="#fe5f2f">
                            <div className="card-icon">
                                <BsLightningCharge size={30} />
                            </div>
                            <h4>Inteligência Artificial</h4>
                            <p>IA que diagnostica o funcionamento da empresa e gera relatórios automatizados, identificando padrões e auxiliando decisões.</p>
                        </SpotlightCard>
                        <SpotlightCard className="custom-spotlight-card" spotlightColor="#fe5f2f">
                            <div className="card-icon">
                                <NotepadText size={30} />
                            </div>
                            <h4>Organização de Tarefas</h4>
                            <p>O sistema conta com um Kanban organizador de tarefas, que pode ser utilizado por todos os colaboradores da empresa.</p>
                        </SpotlightCard>
                        <SpotlightCard className="custom-spotlight-card" spotlightColor="#fe5f2f">
                            <div className="card-icon">
                                <FaChartColumn size={30} />
                            </div>
                            <h4>ERP Completo</h4>
                            <p>Todas as funcionalidades principais de um ERP integradas em uma única plataforma, otimizando recursos e tempo.</p>
                        </SpotlightCard>
                        <SpotlightCard className="custom-spotlight-card" spotlightColor="#fe5f2f">
                            <div className="card-icon" style={{ margin: 0 }}>
                                <StickyNote size={30} />
                            </div>
                            <h4>Geração de Comunicados</h4>
                            <p>O sistema conta com uma ferramenta que permite a geração e publicação de comunicados para os colaboradores da empresa.</p>
                        </SpotlightCard>
                    </Carousel>
                ) : (
                    <div className="card-container">
                        <SpotlightCard className="custom-spotlight-card" spotlightColor="#fe5f2f">
                            <div className="card-icon">
                                <FaRegClock size={30} />
                            </div>
                            <h4>Registro de Ponto Eletrônico</h4>
                            <p>O módulo de ponto eletrônico conta com um sistema físico, que registra a entrada e saída de colaboradores através de um crachá.</p>
                        </SpotlightCard>
                        <SpotlightCard className="custom-spotlight-card" spotlightColor="#fe5f2f">
                            <div className="card-icon">
                                <GoPeople size={30} />
                            </div>
                            <h4>Acessibilidade Garantida</h4>
                            <p>O sistema conta com funcionalidades e uma interface que permitem a sua utilização por pessoas com deficiência.</p>
                        </SpotlightCard>
                        <SpotlightCard className="custom-spotlight-card" spotlightColor="#fe5f2f">
                            <div className="card-icon">
                                <BsLightningCharge size={30} />
                            </div>
                            <h4>Inteligência Artificial</h4>
                            <p>IA que diagnostica o funcionamento da empresa e gera relatórios automatizados, identificando padrões e auxiliando decisões.</p>
                        </SpotlightCard>
                        <SpotlightCard className="custom-spotlight-card" spotlightColor="#fe5f2f">
                            <div className="card-icon">
                                <NotepadText size={30} />
                            </div>
                            <h4>Organização de Tarefas</h4>
                            <p>O sistema conta com um Kanban organizador de tarefas, que pode ser utilizado por todos os colaboradores da empresa.</p>
                        </SpotlightCard>
                        <SpotlightCard className="custom-spotlight-card" spotlightColor="#fe5f2f">
                            <div className="card-icon">
                                <FaChartColumn size={30} />
                            </div>
                            <h4>ERP Completo</h4>
                            <p>Todas as funcionalidades principais de um ERP integradas em uma única plataforma, otimizando recursos e tempo.</p>
                        </SpotlightCard>
                        <SpotlightCard className="custom-spotlight-card" spotlightColor="#fe5f2f">
                            <div className="card-icon" style={{ margin: 0 }}>
                                <StickyNote size={30} />
                            </div>
                            <h4>Geração de Comunicados</h4>
                            <p>O sistema conta com uma ferramenta que permite a geração e publicação de comunicados para os colaboradores da empresa.</p>
                        </SpotlightCard>
                    </div>
                )}
            </div>
            <div id='fourth-section'>
                <h1>Pronto para transformar seu negócio?</h1>
                <p className="section-description">Junte-se às empresas que já descobriram como otimizar processos, aumentar produtividade e garantir o crescimento sustentável.</p>
                <div className="flex-mobile button-container">
                    <button className="try-out">
                        <span>Em breve</span>
                        <FaArrowRight size={16} />
                    </button>
                    <button id="contact">Contato</button>
                </div>
            </div>
            <footer id="footer">
                <div id="footer-container" className="flex-mobile">
                    <div>
                        <img src="./assets/icon.png" alt="Logo Tessilion" />
                        <p>Transformando pequenos negócios através da tecnologia e organização inteligente.</p>
                    </div>
                    <div>
                        <span>Produto</span>
                        <p onClick={() => window.location.href = '#third-section'}>Funcionalidades</p>
                        <p>Demonstração</p>
                    </div>
                    <div>
                        <span>Empresa</span>
                        <p>Sobre</p>
                        <p onClick={() => window.location.href = 'https://www.instagram.com/tessilion.inc'}>Instagram</p>
                        <p onClick={() => window.location.href = 'mailto:projeto.tessilion@gmail.com'}>Contato</p>
                    </div>
                </div>
                <hr />
                <p id="rights">© 2025 Tessilion. Todos os direitos reservados.</p>
            </footer>
        </div >
    )
}

export default LandingPage;
